module.exports = __webpack_public_path__ + "img/gear-L_126x126.99c1865f.png";